import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/sxu/sxu-style.scss';
import Header from '@png/npm-header';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/address-lookup';
import ClearCache from '../../modules/clear-cache';
import CookieBar from '../../modules/cookie-bar';
import LightGallery from '../../modules/light-gallery';
import SmoothScroll from '../../modules/smooth-scroll';
import Sticky from '../../modules/sticky';
import Video from '../../modules/video';
import OverviewPageFilters from '../../modules/overview-page-filters';
import RelatedPagesOverview from '../../modules/related-pages-overview';
import LatestPagesOverview from '../../modules/latest-pages-overview';
import ContentSearch from '../../modules/content-search';
import MarkSearchKeyword from '../../modules/mark-word';
import Recaptcha from '../../modules/recaptcha';

document.addEventListener('DOMContentLoaded', () => {
  const modules = [
    new AddressLookup(),
    new ClearCache(),
    new CookieBar(),
    new Header({
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false
    }),
    new Recaptcha({
      key: '6Leqkv8cAAAAACdVu2-Se-QGCMZq46orfZavBIW4'
    }),
    new LightGallery(),
    new OverviewPageFilters(),
    new RelatedPagesOverview(),
    new LatestPagesOverview(),
    new Sticky({
      velocity: 20
    }),
    new SvgIcon(),
    new SmoothScroll(),
    new Video(),
    new ContentSearch(),
    new MarkSearchKeyword()
  ];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });
});
